/* eslint-disable no-undef */
(function (root, factory) {
    var Backbone, jQuery;

    if (typeof module === 'object' && module.exports) {
        // Backbone requires jquery to be defined by root (window) at build time
        // While our legacy js code has window.$, webpack does not have any global dependencies
        // As a result we're manually adding jquery here https://jira.evbhome.com/browse/EB-67496
        Backbone = require('backbone');
        jQuery = require('jquery');
        Backbone.$ = jQuery;

        module.exports = factory(Backbone, jQuery, require('lodash'));
    } else if (typeof define === 'function' && define.amd) {
        define(['backbone', 'jquery', 'lodash'], factory);
    }
})(this, function (Backbone, $, _) {
    'use strict';

    return Backbone.View.extend({
        config: {
            // Fallback fonts that all browsers support.
            fallbacks: ['monospace', 'sans-serif', 'serif'],
            // Wide, ascending, and descending characters are chosen to increase
            // variability in dimensions between fonts.
            testText: 'mmmmmmmmmmmwwwwwwwhlipqg',
            // Working area is both offscreen and invisible.
            // A large font size is chosen to amplify different font dimensions.
            testCss: {
                fontSize: '157.3px',
                color: 'rgba(255, 255, 255, 0)',
                position: 'absolute',
                left: '-99999px',
                top: '-99999px',
            },
        },

        initialize: function () {
            this.$testElem = $('<span>');
            this.$testElem.text(this.config.testText);
            this.$testElem.css(this.config.testCss);
            this.setUp();
            // Measure and record the dimensions of the fallback fonts.
            this.defaults = this.config.fallbacks.map(
                function (fallback) {
                    return {
                        fallback: fallback,
                        dimensions: this.testOne(fallback, fallback),
                    };
                }.bind(this),
            );
            this.tearDown();
        },

        setUp: function () {
            $('body').append(this.$testElem);
        },

        tearDown: function () {
            this.$testElem.remove();
        },

        testOne: function (font, fallback) {
            this.$testElem.css('font-family', font + ', ' + fallback);
            return (
                this.$testElem.outerWidth() * 10000 +
                this.$testElem.outerHeight()
            );
        },

        testFont: function (font) {
            return _.some(
                this.defaults,
                function (def) {
                    return this.testOne(font, def.fallback) === def.dimensions;
                }.bind(this),
            );
        },
    });
});
